export default "__VITE_ASSET__2Z8ZHe3p__"